export enum SubscriptionMode {
    PLATFORM_API = 'PlatformApi',
    ZEUS = 'Zeus',
    LEGACY_ZUORA = 'LegacyZuora'
}
